/// <reference types="vite/types/importMeta.d.ts" />

export const isViteEnv = typeof import.meta !== 'undefined' && import.meta.env;
// TODO: temporary fix for issue in prod where REACT_APP_ENV is 'production'
export const getAppEnv = (): string | undefined => {
	const appEnv = isViteEnv ? 'VITE_APP_ENV' : 'REACT_APP_ENV';
	return getEnvVar(appEnv) === 'production' ? 'prod' : getEnvVar(appEnv);
};

/**
 * @description Retrieves the value of an environment variable based on the provided key. Env variable
 * only needs mapping if it's acccessed from both vite(PTMD) webpack(all other UIs) and applications.
 * @param key - The key of the environment variable to retrieve.
 * @returns string | undefined - The value of the environment variable if it exists, otherwise undefined.
 */
export const getEnvVar = (key: string): string | undefined => {
	// Prefer Vite style if available
	if (typeof import.meta !== 'undefined' && import.meta.env && key in import.meta.env) {
		const envMappings: Record<string, string | undefined> = {
			VITE_APP_ENV: import.meta.env.VITE_APP_ENV,
			VITE_APP_TEST_ENV_VAR: import.meta.env.VITE_APP_TEST_ENV_VAR,
			VITE_APP_ADO_TEST_ENV_VAR: import.meta.env.VITE_APP_ADO_TEST_ENV_VAR,
			VITE_APP_PTMD_USER_POOL_ID: import.meta.env.VITE_APP_PTMD_USER_POOL_ID,
			VITE_APP_PTMD_CLIENT_ID: import.meta.env.VITE_APP_PTMD_CLIENT_ID,
			VITE_APP_PTMD_IDENTITY_POOL_ID: import.meta.env.VITE_APP_PTMD_IDENTITY_POOL_ID,
			VITE_APP_REGION: import.meta.env.VITE_APP_REGION,
			VITE_APP_PTMD_OAUTH_DOMAIN: import.meta.env.VITE_APP_PTMD_OAUTH_DOMAIN,
			VITE_APP_PTMD_OAUTH_REDIRECT: import.meta.env.VITE_APP_PTMD_OAUTH_REDIRECT,
		};
		return envMappings[key];
		// Fallback to process.env for CRA/Webpack
	} else {
		const envMappings: Record<string, string | undefined> = {
			REACT_APP_ENV:
				process.env.REACT_APP_ENV === 'production' ? 'prod' : process.env.REACT_APP_ENV,
			REACT_APP_REGION: process.env.REACT_APP_REGION,
			REACT_APP_STANDARD_USER_POOL_ID: process.env.REACT_APP_STANDARD_USER_POOL_ID,
			REACT_APP_STANDARD_CLIENT_ID: process.env.REACT_APP_STANDARD_CLIENT_ID,
		};
		return envMappings[key];
	}
};
